import { api, formatDate } from "@/lib/api";

export default function Inbox({ messages, reload }) {
  if (!messages.length) return <p className="border border-[#e2dcd4] bg-white p-6 text-sm text-[#5a665e]" data-testid="seller-inbox-empty">No messages yet.</p>;
  const markRead = (m) => !m.read && api.patch(`/seller/messages/${m.id}`).then(reload);
  return (
    <div className="space-y-3" data-testid="seller-inbox">
      {messages.map((m) => (
        <div key={m.id} onClick={() => markRead(m)} className={`border bg-white p-5 ${m.read ? "border-[#e2dcd4]" : "border-[#c5903b] cursor-pointer"}`} data-testid={`seller-message-${m.id}`}>
          <div className="flex flex-wrap justify-between gap-2">
            <p className="text-[#1a261f]">{m.name} <span className="text-sm text-[#5a665e]">about “{m.listing_title}”</span></p>
            <span className="font-mono-k text-[11px] text-[#5a665e]">{formatDate(m.created_at)}</span>
          </div>
          <p className="mt-3 text-sm text-[#3c4a41] whitespace-pre-line">{m.message}</p>
          {!m.read && <p className="mt-2 font-mono-k text-[10px] uppercase tracking-widest text-[#c5903b]">New · tap to mark read</p>}
          <a href={`mailto:${m.email}?subject=${encodeURIComponent(`Re: ${m.listing_title}`)}`} onClick={(e) => { e.stopPropagation(); markRead(m); }} className="mt-4 inline-block bg-[#1f402b] text-white px-4 py-2 text-sm hover:bg-[#2c5a3d]" data-testid={`seller-message-reply-${m.id}`}>
            Reply to {m.email}
          </a>
        </div>
      ))}
    </div>
  );
}
